import { useGetSelfUserIcon, useSetSelfUserIcon } from 'interface/user'
import { Stack } from '@mui/material'
import { Loading } from 'components/controls/loading'
import { ErrorBlock } from 'components/controls/errorInfo'
import { FileResponse } from 'shared/api'
import { flatten } from 'shared/util'
import { ImageFileInput } from 'components/controls/imageFileInput'

type UserIconFormProps = {
  onChangeUserIcon: (file: FileResponse) => void
}
export const UserIconForm = ({
  onChangeUserIcon
}: UserIconFormProps) => {
  const userIconState = useGetSelfUserIcon()
  const [userIconPostState, setUserIcon] = useSetSelfUserIcon({
    onPosted: onChangeUserIcon
  })
  return (
    <>
      {(userIconState.loading || userIconPostState.posting) && <Loading/>}
      <Stack direction="column" spacing={1} width="200px" justifyContent="center">
        <ErrorBlock error={flatten([userIconState.error, userIconPostState.error])}/>
        <ImageFileInput
          state={userIconState}
          onChangeFile={file => setUserIcon(file)}
          emptyImage={<></>}
          alt="ユーザーアイコン"
        />
      </Stack>
    </>
  )
}